"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconCheckpoint = function IconCheckpoint(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "16px",
    height: "16px",
    className: (0, _classnames.default)('Icon', 'IconCheckpoint', className),
    style: style,
    viewBox: "0 0 16 16"
  }, _react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M2 1.394c0-.185.073-.362.204-.493.153-.153.428-.336.844-.503C3.678.147 4.484 0 5.485 0c.987 0 1.66.192 3.047.747 1.227.49 1.773.647 2.529.647.828 0 1.459-.115 1.919-.299.238-.095.354-.173.376-.194a.697.697 0 0 1 1.19.493v8.364a.697.697 0 0 1-.205.492c-.153.153-.428.337-.844.503-.629.252-1.435.399-2.436.399-.988 0-1.661-.193-3.047-.747-1.228-.491-1.774-.647-2.53-.647-.828 0-1.459.114-1.918.298a2.852 2.852 0 0 0-.172.075v4.505a.697.697 0 0 1-1.394 0V1.394z"
  }));
};

var _default = IconCheckpoint;
exports.default = _default;